"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _buttons = require("../../common/buttons");

const WithStandardPageHeader = WrappedComponent => {
  const StandardPageHeader = props => {
    const {
      onCreateClick,
      className
    } = props,
          otherProps = (0, _objectWithoutProperties2.default)(props, ["onCreateClick", "className"]);
    return /*#__PURE__*/_react.default.createElement(WrappedComponent, (0, _extends2.default)({}, otherProps, {
      className: (0, _classnames.default)('standard-page-header', className)
    }), /*#__PURE__*/_react.default.createElement(_buttons.WhiteButton, {
      onClick: onCreateClick
    }, "Create new"));
  };

  StandardPageHeader.propTypes = {
    onCreateClick: _propTypes.default.func.isRequired,
    className: _propTypes.default.string
  };
  StandardPageHeader.defaultProps = {
    className: ''
  };
  return StandardPageHeader;
};

var _default = WithStandardPageHeader;
exports.default = _default;